$.fn.ajaxUpdateSelect = function () {
  this.each(function () {
    var $masterElem = $(this),
      configData = $masterElem.data("update-select"),
      $slaveElem = $("#" + configData.id),
      defaultFirstOption,
      $submitButton;

    if ($slaveElem.length) {
      // Initialisation
      // -------------------------------------
      defaultFirstOption = _getDefaultOption();
      $submitButton = $("#submit");

      _setSlaveState([defaultFirstOption]);

      // Events
      // --------------------------------------
      $masterElem.on("change", _fetchSlaveContent);
      $slaveElem.on("change", _updateSubmitButtonState);

      // Event handlers
      // --------------------------------------
      function _updateSubmitButtonState(e) {
        if ($slaveElem.val() !== "default") {
          $submitButton.attr("disabled", false); // Enable
        } else {
          $submitButton.attr("disabled", true); // Disable
        }
      }

      function _fetchSlaveContent(e) {
        e.preventDefault(); // will prevent the link above from following the URL.

        $.ajax({
          url: _getRequestURL(),
          data: "",
          dataType: "JSON",
          type: "GET",
        }).done(function (response) {
          var _options = [],
            _opt;
          _options.push(defaultFirstOption);

          for (var key in response.data) {
            if (response.data.hasOwnProperty(key)) {
              _opt =
                '<option value="' +
                response.data[key].userId +
                '">' +
                response.data[key].fullUserName +
                "</option>";
              _opt = $(_opt)[0];
              _options.push(_opt);
            }
          }

          _setSlaveState(_options);
        });
      }

      // Functions
      // ---------------------------------------

      function _getDefaultOption() {
        var _defaultOpt =
          '<option value="default" selected>Select a role</option>';

        var $_first = $slaveElem.find("option:selected:first");

        _defaultOpt =
          $_first.length && $_first.val() === "default"
            ? $_first.prop("outerHTML")
            : _defaultOpt;

        console.log(
          "$firstOption",
          $_first,
          "default",
          _defaultOpt,
          "configData",
          configData,
        );
        return $(_defaultOpt)[0];
      }

      function _setSlaveState(options) {
        // Empty 'slave' element and set default state
        $slaveElem.empty();

        _updateSlaveOptionsList(options);

        // Disable submit button
        $submitButton.attr("disabled", true);
      }

      function _updateSlaveOptionsList(optionsArray) {
        if ($.isArray(optionsArray)) {
          $.each(optionsArray, function () {
            if ($(this).is("option")) {
              $slaveElem.append($(this));
            }
          });
        }
      }

      function _getRequestURL() {
        var _url = "";

        if (!$.isEmptyObject(configData.url)) {
          _url = configData.url.split("?")[0];

          _url = _url + "?role=" + $masterElem.val();
        }

        return _url;
      }
    }
  });
};
